<button (click)="onClick($event)" [disabled]="disabled" [id]="id"
        [ngStyle]="{'font-size': fontSize}" class="{{theme}}"
        mat-button>{{text}}</button>
